module.exports = __webpack_public_path__ + "static/img/emt_example_payment10.9735768.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emt_example_payment10.jpg
// module id = /nZC
// module chunks = 0